const Permissions = {
    EDITAR_PERMISSOES: 1,
    CRIAR_USUARIO: 2,
    TELA_PARCEIRO: 3,
    REMOVER_PERMISSOES: 4,
    EDITAR_PERMISSOES_GERAIS: 5,
    EDITAR_PERMISSOES_PARCEIRO: 6,
    CADASTRAR_APLICACAO: 7,
    EDITAR_APLICACAO: 8,
    EXCLUIR_APLICACAO: 9,
    CADASTRAR_ROLE: 10,
    EDITAR_ROLE: 11,
    EXCLUIR_ROLE: 12,
    EDITAR_PARTNER: 13,
    CADASTRAR_PARTNER: 14,
    EXCLUIR_PARTNER: 15,
    VINCULAR_PARCEIRO: 16,
    CRIAR_USUARIO_SIMPLES: 17,
    LISTAR_PARTNERS_COMPLETO: 18,  
    CADASTRAR_FUNCAO: 19,
    EDITAR_FUNCAO: 20,
    EXCLUIR_FUNCAO: 21,    
    CADASTRAR_MODULO: 22,
    EDITAR_MODULO: 23,
    EXCLUIR_MODULO: 24, 
    ASSOCIAR_FUNCAO: 25,
    ASSOCIAR_MODULE: 26,
    TELA_FEEDBACK: 27,
    LISTAR_ROLES_CENTRAL_AJUDA: 28,
    LISTAR_ROLES_COMPLETO: 29,
    CADASTRAR_CERTIFICACAO: 30,
    EDITAR_CERTIFICACAO: 31,
    EXCLUIR_CERTIFICACAO: 32,
    VISUALIZAR_CERTIFICACAO: 33,
    CADASTRAR_NOTIFICACAO: 34,
    EDITAR_NOTIFICACAO: 35,
    EXCLUIR_NOTIFICACAO: 36,
    VISUALIZAR_NOTIFICACAO: 37,
    EDITAR_EMAIL_PRINCIPAL: 39,
    LISTAR_ROLES_EXPERIENCE: 40
  }
  
  export default Permissions